import styled from 'styled-components';

export const ToolbarContainer = styled.div<{ $isCompact?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ $isCompact }) => ($isCompact ? '1.25rem' : '2rem')};
  flex-wrap: wrap;
  gap: ${({ $isCompact }) => ($isCompact ? '0.75rem' : '1.5rem')};
`;

export const ToolbarLeft = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
`;

export const ToolbarRight = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  align-items: center;
`;

export const ViewToggleContainer = styled.div<{ $isCompact?: boolean }>`
  display: flex;
  gap: 0.2rem;
  background: ${({ $isCompact, theme }) =>
    $isCompact ? theme.colors.background : '#f5f5f5'};
  border-radius: ${({ $isCompact, theme }) =>
    $isCompact ? theme.borderRadius.sm : '8px'};
  padding: 0.2rem;
  border: 1px solid
    ${({ $isCompact, theme }) =>
      $isCompact ? theme.colors.border.light : '#e0e0e0'};
`;

export const ViewToggleButton = styled.button<{
  active?: boolean;
  $isCompact?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: ${({ active }) => (active ? '600' : '500')};

  svg {
    font-size: 0.95em;
  }

  ${({ $isCompact, active, theme }) =>
    $isCompact
      ? `
    padding: 0.35rem 0.7rem;
    border-radius: ${theme.borderRadius.sm};
    background: ${active ? theme.colors.background : 'transparent'};
    color: ${active ? theme.colors.primary : theme.colors.text.secondary};
    font-size: 0.8rem;
    box-shadow: ${active ? '0 1px 3px rgba(15, 23, 42, 0.08)' : 'none'};

    &:hover {
      color: ${theme.colors.primary};
    }
  `
      : `
    padding: 0.5rem 1rem;
    border-radius: 6px;
    background: ${active ? 'white' : 'transparent'};
    color: ${active ? '#1976d2' : '#666'};
    font-size: 0.875rem;
    box-shadow: ${active ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none'};

    &:hover {
      background: ${active ? 'white' : '#e8e8e8'};
    }
  `}
`;

export const ActionButtonsContainer = styled.div<{ $isCompact?: boolean }>`
  display: flex;
  gap: ${({ $isCompact }) => ($isCompact ? '0.5rem' : '0.75rem')};
  flex-wrap: wrap;
  align-items: center;
`;
